import { render, staticRenderFns } from "./DocumentViewerDialog.vue?vue&type=template&id=32c11cf8"
import script from "./DocumentViewerDialog.vue?vue&type=script&lang=js"
export * from "./DocumentViewerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports